import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import Snackbar from '~/components/@extended/Snackbar';
import Locales from '~/components/Locales';
import RTLLayout from '~/components/RTLLayout';
import ScrollTop from '~/components/ScrollTop';
import Notistack from '~/components/third-party/Notistack';
import { ApolloAuthProvider } from '~/contexts/ApolloAuthProvider';
import { JWTProvider as CognitoAuthProvider } from '~/contexts/JWTContextCognito';
import router from '~/routes';
import { ThemeProvider } from '~/themes/ThemeProvider';
import { queryClient } from '~/utils/query-client';

import LaunchDarklyUserIdentifier from './components/flags/LaunchDarklyUserIdentifier';

// @ts-ignore
window.logVersion = () => {
  console.log(`Commit Hash: https://github.com/topsteptrader/trm/commit/${process.env.commit}`);
};

const App = () => {
  const AuthProvider = CognitoAuthProvider;

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LaunchDarklyUserIdentifier>
          <ApolloAuthProvider>
            <ThemeProvider>
              <RTLLayout>
                <Locales>
                  <ScrollTop>
                    <Notistack>
                      <RouterProvider router={router} />
                      <Snackbar />
                    </Notistack>
                  </ScrollTop>
                </Locales>
              </RTLLayout>
            </ThemeProvider>
          </ApolloAuthProvider>
        </LaunchDarklyUserIdentifier>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
